module.exports = __webpack_public_path__ + "media/images/emblems/Escholzmatt_LU-e13ea67c843ed863e4eda75f4d083edf.png";